require('../modules/es.array.iterator');
require('../modules/es.object.to-string');
require('../modules/es.map');
require('../modules/es.set');
require('../modules/web.structured-clone');
var path = require('../internals/path');

module.exports = path.structuredClone;
